//@3rd Party
import { FC, ReactNode, useMemo } from "react"
// _______________________________________________________________

//@Mui
import { ThemeProvider } from "@mui/material"
// _______________________________________________________________

//@Hooks
import CssBaseline from "@mui/material/CssBaseline"
import i18n from "i18next"
import { ReactCacheProvider } from "ideep-design-system-2"

// import customTheme from './theme'
// _______________________________________________________________

//States
import { useCommon } from "~/store/common/commonSlice"
import customTheme from "~/theme/theme"

// _______________________________________________________________

//@Types
interface AppThemeProps {
  children: ReactNode
}

const AppTheme: FC<AppThemeProps> = ({ children }) => {
  const { themeMode = "light", isRtl, lang } = useCommon()
  document.documentElement.classList.add("fa-font")
  const changeFont = (direction: "rtl" | "ltr") => {
    document.documentElement.lang = direction === "rtl" ? "fa" : "en"
    document.documentElement.dir = direction
    if (direction === "ltr") {
      //TODO Find a more optimized way to change font on language changes
      document.documentElement.classList.replace("fa-font", "en-font")
    }
  }

  const changeLang = (lang: string | undefined) => {
    i18n.changeLanguage(lang ?? "fa")
  }

  // const theme = useMemo(() => customTheme(themeMode, isRtl), [themeMode, isRtl])
  const theme = useMemo(() => customTheme("light", isRtl), [themeMode, isRtl])

  changeFont(isRtl ? "rtl" : "ltr")
  changeLang(lang)

  return (
    <ReactCacheProvider isRtl={isRtl}>
      <CssBaseline />

      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </ReactCacheProvider>
  )
}

export default AppTheme
